define('views/components/recurring_product/recurring_product',['require','backbone','text!templates/components/recurring_product/recurring_product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/recurring_product/recurring_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'recurring-product-item',

        initialize: function() {
            // Add expired class if license expired
            if (this.model.get('end_time') && new Date(this.model.get('end_time')) < new Date()) {
                this.$el.addClass('expired');
            }
        },

        ui: function() {
            return {
                cancelButton: '#cancel-button',
                // revokeButton: '#revoke-button'
            };
        },

        events: {
            'click @ui.cancelButton': 'cancelButtonClicked',
            // 'click @ui.revokeButton': 'revokeButtonClicked'
        },

        cancelButtonClicked:  function () {

            var _this = this;
            App.utils.showConfirmModal(App.polyglot.t('cancel_subscription_confirm_message'), function () {
                _this._cancel();
            });
        },

        _cancel: function () {
            var _this = this;

            this.ui.cancelButton.addClass('loading');

            $.ajax({
                url: App.Config.apiBase + 'recurring-licenses/' + this.model.get('id') + '/cancel/',
                method: 'post',
                success: function (response) {
                    _this.model.set('is_owner', false);
                    _this.model.set('is_activated', false);

                    _this.render();

                    App.utils.showMessage('success', App.polyglot.t('cancel_success'));

                    _this.ui.cancelButton.removeClass('loading');
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    // Show error messages
                    if (xhr.responseJSON.errors) {
                        for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                            App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                        }
                    }

                    _this.ui.cancelButton.removeClass('loading');

                }
            });
        }
    });
});
